import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging } from '../paged-results/limit-offset-paging.model';

export class PrescriptionListSettings {
  filters: null;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class PrescriptionQueueSettings extends PrescriptionListSettings implements UserQueueSettings {
  position: number;
}
